import {
  Box,
  Container,
  CssBaseline,
  Grid,
  ThemeProvider,
  Typography,
  useMediaQuery,
} from "@mui/material";
import theme from "../../../config/theme";
import { useEffect, useState } from "react";
import Accordion from "@mui/material/Accordion";
import AccordionDetails from "@mui/material/AccordionDetails";
import AccordionSummary from "@mui/material/AccordionSummary";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import CancelIcon from "@mui/icons-material/Cancel";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";

export const allHeadings = [
  {
    headings: [
      {
        panel: "panel1",
        title: "Heading1",
        subheadings: [
          {
            subtitle: "Feature 1",
            gridData: [{ title: "1" }, { title: "2" }, { title: "4" }],
          },
          {
            subtitle: "Feature 2",
            gridData: [
              { title: <CancelIcon /> },
              { title: <CheckCircleIcon /> },
              { title: <CheckCircleIcon /> },
            ],
          },
          {
            subtitle: "Feature 3",
            gridData: [
              { title: "1 MONTHS" },
              { title: "3 MONTHS" },
              { title: "LIFETIME" },
            ],
          },
          {
            subtitle: "Feature 4",
            gridData: [
              { title: <CancelIcon /> },
              { title: <CheckCircleIcon /> },
              { title: <CheckCircleIcon /> },
            ],
          },
        ],
      },
      {
        panel: "panel2",
        title: "Heading2",
        subheadings: [
          {
            subtitle: "subheading2.1",
            gridData: [{ title: "a" }, { title: "b" }, { title: "c" }],
          },
          {
            subtitle: "subheading2.2",
            gridData: [{ title: "d" }, { title: "e" }, { title: "f" }],
          },
          {
            subtitle: "subheading2.3",
            gridData: [{ title: "g" }, { title: "h" }, { title: "i" }],
          },
          {
            subtitle: "subheading2.4",
            gridData: [{ title: "j" }, { title: "k" }, { title: "l" }],
          },
        ],
      },
      {
        panel: "panel3",
        title: "Heading3",
        subheadings: [
          {
            subtitle: "subheading3.1",
            gridData: [{ title: "a" }, { title: "b" }, { title: "c" }],
          },
          {
            subtitle: "subheading3.2",
            gridData: [{ title: "d" }, { title: "e" }, { title: "f" }],
          },
          {
            subtitle: "subheading3.3",
            gridData: [{ title: "g" }, { title: "h" }, { title: "i" }],
          },
          {
            subtitle: "subheading3.4",
            gridData: [{ title: "j" }, { title: "k" }, { title: "l" }],
          },
        ],
      },
      {
        panel: "panel4",
        title: "Heading4",
        subheadings: [
          {
            subtitle: "subheading4.1",
            gridData: [{ title: "a" }, { title: "b" }, { title: "c" }],
          },
          {
            subtitle: "subheading4.2",
            gridData: [{ title: "d" }, { title: "e" }, { title: "f" }],
          },
          {
            subtitle: "subheading4.3",
            gridData: [{ title: "g" }, { title: "h" }, { title: "i" }],
          },
          {
            subtitle: "subheading4.4",
            gridData: [{ title: "j" }, { title: "k" }, { title: "l" }],
          },
        ],
      },
    ],
  },
  {
    headings: [
      {
        panel: "panel5",
        title: "Heading5",
        subheadings: [
          {
            subtitle: "Feature 5",
            gridData: [{ title: "1" }, { title: "2" }, { title: "4" }],
          },
          {
            subtitle: "Feature 6",
            gridData: [
              { title: <CancelIcon /> },
              { title: <CheckCircleIcon /> },
              { title: <CheckCircleIcon /> },
            ],
          },
          {
            subtitle: "Feature 7",
            gridData: [
              { title: "1 MONTHS" },
              { title: "3 MONTHS" },
              { title: "LIFETIME" },
            ],
          },
          {
            subtitle: "Feature 8",
            gridData: [
              { title: <CancelIcon /> },
              { title: <CheckCircleIcon /> },
              { title: <CheckCircleIcon /> },
            ],
          },
        ],
      },
      {
        panel: "panel6",
        title: "Heading6",
        subheadings: [
          {
            subtitle: "subheading6.1",
            gridData: [{ title: "a" }, { title: "b" }, { title: "c" }],
          },
          {
            subtitle: "subheading6.2",
            gridData: [{ title: "d" }, { title: "e" }, { title: "f" }],
          },
          {
            subtitle: "subheading6.3",
            gridData: [{ title: "g" }, { title: "h" }, { title: "i" }],
          },
          {
            subtitle: "subheading6.4",
            gridData: [{ title: "j" }, { title: "k" }, { title: "l" }],
          },
        ],
      },
      {
        panel: "panel7",
        title: "Heading7",
        subheadings: [
          {
            subtitle: "subheading7.1",
            gridData: [{ title: "a" }, { title: "b" }, { title: "c" }],
          },
          {
            subtitle: "subheading7.2",
            gridData: [{ title: "d" }, { title: "e" }, { title: "f" }],
          },
          {
            subtitle: "subheading7.3",
            gridData: [{ title: "g" }, { title: "h" }, { title: "i" }],
          },
          {
            subtitle: "subheading7.4",
            gridData: [{ title: "j" }, { title: "k" }, { title: "l" }],
          },
        ],
      },
      {
        panel: "panel8",
        title: "Heading8",
        subheadings: [
          {
            subtitle: "subheading8.1",
            gridData: [{ title: "a" }, { title: "b" }, { title: "c" }],
          },
          {
            subtitle: "subheading8.2",
            gridData: [{ title: "d" }, { title: "e" }, { title: "f" }],
          },
          {
            subtitle: "subheading8.3",
            gridData: [{ title: "g" }, { title: "h" }, { title: "i" }],
          },
          {
            subtitle: "subheading8.4",
            gridData: [{ title: "j" }, { title: "k" }, { title: "l" }],
          },
        ],
      },
    ],
  },
  {
    headings: [
      {
        panel: "panel9",
        title: "Heading9",
        subheadings: [
          {
            subtitle: "Feature 9",
            gridData: [{ title: "1" }, { title: "2" }, { title: "4" }],
          },
          {
            subtitle: "Feature 10",
            gridData: [
              { title: <CancelIcon /> },
              { title: <CheckCircleIcon /> },
              { title: <CheckCircleIcon /> },
            ],
          },
          {
            subtitle: "Feature 11",
            gridData: [
              { title: "1 MONTHS" },
              { title: "3 MONTHS" },
              { title: "LIFETIME" },
            ],
          },
          {
            subtitle: "Feature 12",
            gridData: [
              { title: <CancelIcon /> },
              { title: <CheckCircleIcon /> },
              { title: <CheckCircleIcon /> },
            ],
          },
        ],
      },
      {
        panel: "panel10",
        title: "Heading10",
        subheadings: [
          {
            subtitle: "subheading10.1",
            gridData: [{ title: "a" }, { title: "b" }, { title: "c" }],
          },
          {
            subtitle: "subheading10.2",
            gridData: [{ title: "d" }, { title: "e" }, { title: "f" }],
          },
          {
            subtitle: "subheading10.3",
            gridData: [{ title: "g" }, { title: "h" }, { title: "i" }],
          },
          {
            subtitle: "subheading10.4",
            gridData: [{ title: "j" }, { title: "k" }, { title: "l" }],
          },
        ],
      },
      {
        panel: "panel11",
        title: "Heading11",
        subheadings: [
          {
            subtitle: "subheading11.1",
            gridData: [{ title: "a" }, { title: "b" }, { title: "c" }],
          },
          {
            subtitle: "subheading11.2",
            gridData: [{ title: "d" }, { title: "e" }, { title: "f" }],
          },
          {
            subtitle: "subheading11.3",
            gridData: [{ title: "g" }, { title: "h" }, { title: "i" }],
          },
          {
            subtitle: "subheading11.4",
            gridData: [{ title: "j" }, { title: "k" }, { title: "l" }],
          },
        ],
      },
      {
        panel: "panel12",
        title: "Heading12",
        subheadings: [
          {
            subtitle: "subheading12.1",
            gridData: [{ title: "a" }, { title: "b" }, { title: "c" }],
          },
          {
            subtitle: "subheading12.2",
            gridData: [{ title: "d" }, { title: "e" }, { title: "f" }],
          },
          {
            subtitle: "subheading12.3",
            gridData: [{ title: "g" }, { title: "h" }, { title: "i" }],
          },
          {
            subtitle: "subheading12.4",
            gridData: [{ title: "j" }, { title: "k" }, { title: "l" }],
          },
        ],
      },
    ],
  },
];

const Features = ({ active }) => {
  const [expanded, setExpanded] = useState([]);
  useEffect(() => {
    const initialExpanded = allHeadings.map((item) => item.headings[0].panel);
    setExpanded(initialExpanded);
  }, []);

  const handleChange = (panel) => (event, isExpanded) => {
    setExpanded((prevExpanded) => {
      if (isExpanded) {
        return prevExpanded.includes(panel)
          ? prevExpanded
          : [...prevExpanded, panel];
      } else {
        return prevExpanded.filter((p) => p !== panel);
      }
    });
  };

  const isMobile = useMediaQuery((theme) => theme.breakpoints.down("sm"));

  return (
    <ThemeProvider theme={theme}>
      <CssBaseline />
      <Container>
        <Box sx={{ display: { xs: "none", sm: "block" } }}>
          {allHeadings.map((item, index) => (
            <Box
              key={index}
              sx={{
                marginTop: "3.75rem",
                display: active === index ? "block" : "none",
              }}
            >
              {item.headings.map((item, index) => (
                <Accordion
                  key={index}
                  expanded={expanded.includes(item.panel)}
                  onChange={handleChange(item.panel)}
                  sx={{
                    boxShadow: "none",
                    borderBottom: `1px solid ${theme.palette.primary.main}`,
                    "&.Mui-expanded": {
                      margin: 0,
                    },
                  }}
                >
                  <AccordionSummary
                    expandIcon={
                      <ExpandMoreIcon
                        sx={{ color: `${theme.palette.primary.main}` }}
                      />
                    }
                  >
                    <Typography
                      variant="h6"
                      sx={{
                        color: `${theme.palette.primary.main}`,
                        fontSize: "1.25rem",
                        letterSpacing: "0.01rem",
                        fontWeight: 700,
                      }}
                    >
                      {item.title}
                    </Typography>
                  </AccordionSummary>
                  <AccordionDetails>
                    <Box
                      sx={{
                        display: "flex",
                        flexDirection: "column",
                      }}
                    >
                      {item.subheadings.map((subheading, subIndex) => (
                        <Box
                          key={subIndex}
                          sx={{
                            display: "flex",
                            alignItems: "center",
                          }}
                        >
                          <Box sx={{ display: "flex", flex: 1 }}>
                            <Typography
                              variant="h6"
                              sx={{
                                fontSize: "1.25rem",
                                fontWeight: 700,
                                letterSpacing: "0.01rem",
                                color: "#212121",
                              }}
                            >
                              {subheading.subtitle}
                            </Typography>
                          </Box>
                          <Box sx={{ display: "flex", flex: 3 }}>
                            <Grid container spacing={2}>
                              {subheading.gridData.map((item, index) => (
                                <Grid item xs={4} key={index}>
                                  <Box
                                    sx={{
                                      border: ` 0.4px solid ${theme.palette.primary.main}`,
                                      height: "3rem",
                                      width: "15.5rem",
                                      marginBottom: "0.75rem",
                                    }}
                                  >
                                    <Box
                                      sx={{
                                        display: "flex",
                                        justifyContent: "center",
                                        margin: "0.75rem",
                                        fontSize: "0.875rem",
                                      }}
                                    >
                                      {item.title}
                                    </Box>
                                  </Box>
                                </Grid>
                              ))}
                            </Grid>
                          </Box>
                        </Box>
                      ))}
                    </Box>
                  </AccordionDetails>
                </Accordion>
              ))}
            </Box>
          ))}
        </Box>
        <Box
          sx={{
            marginTop: ["2.5rem", "3.75rem"],
            marginBottom: ["3.75rem", "8.125rem"],
          }}
        >
          <Typography
            variant="h6"
            sx={{
              fontSize: ["0.75rem", "1.25rem"],
              fontWeight: 400,
              letterSpacing: ["0.0079055rem", "0.01rem"],
              color: "#212121",
              ...(isMobile && {
                textAlign: "center",
              }),
            }}
          >
            Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do
            eiusmod tempor incididunt ut labore et dolore magna aliqua.
          </Typography>
        </Box>
      </Container>
    </ThemeProvider>
  );
};

export default Features;
